import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import Profile from './components/Profile/Profile';
import ServiceRequests from './components/ServiceRequests/ServiceRequests';
import JoinFamily from './components/JoinFamily/JoinFamily';
import AllTransactions from './components/AllTransactions/AllTransactions';
import QuickDonate from '../../Components/NewQuickDon/QuickDonate';
import style from './dashboard.module.css';
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const { user, logout } = useContext(AuthContext);
  
  const [activeTab, setActiveTab] = useState('profile');

  const navigate = useNavigate()

  const renderContent = () => {
    switch (activeTab) {
      case 'profile':
        return <Profile />;
      case 'service':
        return <ServiceRequests />;
      case 'join':
        return <JoinFamily />;
      case 'transactions':
        return <AllTransactions />;
      case 'donate':
        return <QuickDonate />;
      default:
        return <Profile />;
    }
  };

  return (
    <>
      <Header />

      <main className={style.dashboardSection}>
        <div className={style['dashboard-navbar']}>
          <button
            className={`${style['dashboard-navbar-button']} ${activeTab === 'profile' ? style['dashboard-navbar-active'] : ''}`}
            onClick={() => setActiveTab('profile')}
          >
            Profile
          </button>

          {/* <button
            className={`${style['dashboard-navbar-button']} ${activeTab === 'service' ? style['dashboard-navbar-active'] : ''}`}
            onClick={() => setActiveTab('service')}
          >
            Service Request
          </button> */}

          <button
            className={`${style['dashboard-navbar-button']} ${activeTab === 'join' ? style['dashboard-navbar-active'] : ''}`}
            onClick={() => setActiveTab('join')}
          >
            Join Family
          </button>

          <button
            className={`${style['dashboard-navbar-button']} ${activeTab === 'transactions' ? style['dashboard-navbar-active'] : ''}`}
            onClick={() => setActiveTab('transactions')}
          >
            All Transactions
          </button> 

          <button
            className={`${style['dashboard-navbar-button']} ${activeTab === 'donate' ? style['dashboard-navbar-active'] : ''}`}
            onClick={() => navigate('/QuickDonate', { state: { component: "donateMore" } })}
          >
            Donate More
          </button>
        </div>

        <div className={style['dashboard-content']}>
          {renderContent()}
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Dashboard;
